import { LocationQuery, LocationQueryValue } from 'vue-router';
import { Store } from 'vuex';

import { AppState } from '@/store/types';

export const hasHowProperties = async (store: Store<AppState>): Promise<boolean> => {
  const properties = await store.dispatch('common/fetchUserProperties');

  return Boolean(properties && properties.length > 0);
};

const getSingleQueryValue = (value: LocationQueryValue | LocationQueryValue[]): string => {
  const singleValue = Array.isArray(value) ? value[0] : value;
  return singleValue?.trim() ? singleValue : '';
};

export const getHowSourceFromQuery = (query: LocationQuery): string => {
  return getSingleQueryValue(query.source) || getSingleQueryValue(query.utm_source);
};
